import { createSelector } from 'reselect'
import api from './api'
import { combineReducers } from '../../node_modules/redux'

const stateLinkSelector = (state) => state.paymentLinks

export const selector = createSelector(
    [stateLinkSelector],
    (paymentLinks) => {
        return { ...paymentLinks }
    }
)

const PAYMENT_LINK__FETCH_ALL_REQUEST = 'PAYMENT_LINK__FETCH_ALL_REQUEST'
const PAYMENT_LINK__FETCH_ALL_SUCCESS = 'PAYMENT_LINK__FETCH_ALL_SUCCESS'
const PAYMENT_LINK__FETCH_ALL_FAILURE = 'PAYMENT_LINK__FETCH_ALL_FAILURE'

const PAYMENT_LINK__FETCH_SINGLE_REQUEST = 'PAYMENT_LINK__FETCH_SINGLE_REQUEST'
const PAYMENT_LINK__FETCH_SINGLE_SUCCESS = 'PAYMENT_LINK__FETCH_SINGLE_SUCCESS'
const PAYMENT_LINK__FETCH_SINGLE_FAILURE = 'PAYMENT_LINK__FETCH_SINGLE_FAILURE'

const PAYMENT_LINK__CREATE_REQUEST = 'PAYMENT_LINK__CREATE_REQUEST'
const PAYMENT_LINK__CREATE_SUCCESS = 'PAYMENT_LINK__CREATE_SUCCESS'
const PAYMENT_LINK__CREATE_FAILURE = 'PAYMENT_LINK__CREATE_FAILURE'

const PAYMENT_LINK__UPDATE_REQUEST = 'PAYMENT_LINK__UPDATE_REQUEST'
const PAYMENT_LINK__UPDATE_SUCCESS = 'PAYMENT_LINK__UPDATE_SUCCESS'
const PAYMENT_LINK__UPDATE_FAILURE = 'PAYMENT_LINK__UPDATE_FAILURE'

const PAYMENT_LINK_PRODUCTS__FETCH_ALL_REQUEST = 'PAYMENT_LINK_PRODUCTS__FETCH_ALL_REQUEST'
const PAYMENT_LINK_PRODUCTS__FETCH_ALL_SUCCESS = 'PAYMENT_LINK_PRODUCTS__FETCH_ALL_SUCCESS'
const PAYMENT_LINK_PRODUCTS__FETCH_ALL_FAILURE = 'PAYMENT_LINK_PRODUCTS__FETCH_ALL_FAILURE'

const initialState = {
    paymentLinks: {},
    products: [],
}

export const actionCreators = {
    getProducts: () =>
        api({
            types: [PAYMENT_LINK_PRODUCTS__FETCH_ALL_REQUEST, PAYMENT_LINK_PRODUCTS__FETCH_ALL_SUCCESS, PAYMENT_LINK_PRODUCTS__FETCH_ALL_FAILURE],
            uri: '/api/paymentLinks/products',
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
            sendJwtBearer: true,
        }),
    getPaymentLink: (linkId) =>
        api({
            types: [PAYMENT_LINK__FETCH_SINGLE_REQUEST, PAYMENT_LINK__FETCH_SINGLE_SUCCESS, PAYMENT_LINK__FETCH_SINGLE_FAILURE],
            uri: `/api/paymentLinks/${linkId}`,
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
            sendJwtBearer: true,
        }),
    getPaymentLinks: () =>
        api({
            types: [PAYMENT_LINK__FETCH_ALL_REQUEST, PAYMENT_LINK__FETCH_ALL_SUCCESS, PAYMENT_LINK__FETCH_ALL_FAILURE],
            uri: '/api/paymentLinks',
            config: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            },
            sendJwtBearer: true,
        }),
    createPaymentLink: (paymentLink) =>
        api({
            types: [PAYMENT_LINK__CREATE_REQUEST, PAYMENT_LINK__CREATE_SUCCESS, PAYMENT_LINK__CREATE_FAILURE],
            uri: '/api/paymentLinks',
            config: {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(paymentLink),
            },
            payload: paymentLink,
            sendJwtBearer: true,
        }),
    updatePaymentLink: (paymentLink) =>
        api({
            types: [PAYMENT_LINK__UPDATE_REQUEST, PAYMENT_LINK__UPDATE_SUCCESS, PAYMENT_LINK__UPDATE_FAILURE],
            uri: `/api/paymentLinks/${paymentLink.id}`,
            config: {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(paymentLink),
            },
            payload: paymentLink,
            sendJwtBearer: true,
        }),
}

const paymentLinks = (state = initialState.paymentLinks, action) => {
    switch (action.type) {
        case PAYMENT_LINK__CREATE_SUCCESS:
            return { ...state, [action.response.id]: action.response }
        case PAYMENT_LINK__FETCH_ALL_SUCCESS:
            return {
                ...state,
                ...action.response.reduce((obj, item) => {
                    obj[item.id] = item
                    return obj
                }, {}),
            }
        case PAYMENT_LINK__UPDATE_SUCCESS:
            return { ...state, [action.response.id]: action.response }
        case PAYMENT_LINK__FETCH_SINGLE_SUCCESS:
            return { ...state, ...{ [action.response.id]: action.response } }

        default:
            return { ...state }
    }
}

const products = (state = initialState.products, action) => {
    switch (action.type) {
        case PAYMENT_LINK_PRODUCTS__FETCH_ALL_SUCCESS:
            return [...action.response]
        default:
            return state
    }
}

export const reducer = combineReducers({
    paymentLinks,
    products,
})
